import Vue from 'vue';
import formatNumber from '~/lib/formatNumber';

export default Vue.filter('formatNumber', (value, locale, decimalPlaces = 2, minDecimalPlaces = null) => formatNumber(value, locale, decimalPlaces, minDecimalPlaces));
